import SvgIcon from 'components/commons/icons/SvgIcon';
import React from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { priorityMessageState, updateShowPriorityMessage } from 'redux/slices/alertsSlice';
import { ReactComponent as Ic_WarningCircle } from 'resources/icons/Ic_Warning_Priority.svg';

export default function PriorityMessageAlert() {
  const dispatch = useDispatch();
  const priorityMessage = useSelector(priorityMessageState);

  return priorityMessage &&
    priorityMessage?.message &&
    priorityMessage?.showPriorityMessage &&
    new Date(priorityMessage?.message?.startDate) <= new Date() &&
    (priorityMessage?.message?.endDate
      ? new Date() >= new Date(priorityMessage?.message?.endDate)
      : true) ? (
    <div className='message-priority'>
      <SvgIcon ariaLabel='alert-icon' Icon={Ic_WarningCircle} className='icon-message' />
      <div style={{ flex: 1 }}>{priorityMessage.message?.text}</div>
      <div className='close-button' onClick={() => dispatch(updateShowPriorityMessage(false))}>
        X
      </div>
    </div>
  ) : null;
}
